import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { initPage } from '../App';

const Page1 = () => {
  const [isCursorSet, setIsCursorSet] = useState(false);
  const [cursorUrl, setCursorUrl] = useState('/seta-direita.png');
  const [openPrompt, setOpenPrompt] = useState(false);
  const [textValue, setTextValue] = useState('');
  const [incensarioActive, setIncensarioActive] = useState(false);
  const [lamparinaActive, setLamparinaActive] = useState(false);
  const [paredeTextActive, setParedeTextActive] = useState(false);

  const navigate = useNavigate();

  const incensarioText = <span>
    Faz tempo que não acendo os esses incensos. <br/>
    Ainda assim, o cheiro adocicado permanece na sala. 
  </span>

  const lamparinaText = <span>
    Lamparinas fosfoluminescentes oferecidas pela DURN. <br/>
    Se deixar elas pegando sol desde a manhã, duram a noite inteira.
  </span>

  const paredeText = <span>
    Eu escrevo minhas maiores vontades com giz nessa parede, <br/>
    ouvi dizer que dá sorte. O último desejo foi passar em Direito Internacional… <br/>
    mas isso já passou. Acho que tá na hora de escrever outra coisa.
  </span>


  const handleSetCursor = (url) => {
    setIsCursorSet(!isCursorSet);
    if (url) {
      setCursorUrl(url);
    }
  };

  const handleWallClick = () => {
    if (!isCursorSet) {
      setParedeTextActive(true)
      return;
    }
    setOpenPrompt(!openPrompt);
  };

  const handleSubmit = () => {
    if (textValue.trim().toLowerCase() === 'descobrir o oceano inteiro') {
      navigate('/5');
    }
  };

  const handleIncensarioClick = () => {
    setIncensarioActive(true);
  }

  const handleLamparinaClick = () => {
    setLamparinaActive(true);
  }

  useEffect(() => {
    initPage();
  }, [])

  return (
    <div className="page-container">
      <div 
        style={{ 
          cursor: isCursorSet ? `url('${cursorUrl}'), auto` : 'default',
          width: '100%',
          height: '100%'
        }}
      >
        <img 
          src="/SALA-1.png" 
          alt="Background" 
          className="background-image"
        />
        {/* Incensario */}
        <div 
          className="clickable-area"
          style={{
            top: '59%',
            left: '40%',
            width: '16%',
            height: '35%',
            opacity: 0.0,
            background: 'red'
          }}
          onClick={handleIncensarioClick}
        />

        {/* Lamparina */}
        <div 
          className="clickable-area"
          style={{
            top: '70%',
            left: '31%',
            width: '12%',
            height: '30%',
            opacity: 0.0,
            background: 'red'
          }}
          onClick={handleLamparinaClick}
        />
        
        {/* Área do giz */}
        <div 
          style={{
            top: '88%',
            left: '54.5%',
            width: '8.5%',
            height: '8.5%',
            opacity: 0.0,
            background: 'red'
          }}
          onClick={() => handleSetCursor('/giz.png')}
          className="clickable-area"
        />

        
        {/* Área da parede */}
        {
          <div 
            className="clickable-area"
            style={{
              top: '0%',
              left: '26%',
              width: '50%',
              height: '40%',
              cursor: isCursorSet ? `url('${cursorUrl}'), auto` : 'pointer'
            }}
            onClick={handleWallClick}
          />
        }

        {/* Porta direita */}
        <div 
          className="clickable-area seta-direita"
          style={{
            top: '10%',
            left: '90%',
            width: '10%',
            height: '90%',
          }}
          onClick={() => navigate('/4')}
        />

        {/* Porta esquerda */}
        <div 
          className="clickable-area seta-esquerda"
          style={{
            top: '10%',
            left: '0%',
            width: '10%',
            height: '90%',
          }}
          onClick={() => navigate('/2')}
        />
        
        {/* Área do prompt */}
        {openPrompt && (
          <div className="prompt-area">
            <div className="close-button" onClick={handleWallClick}>
              X
            </div>
            <textarea
              cols="30"
              rows="1"
              value={textValue}
              onChange={(e) => setTextValue(e.target.value)}
            />
            <div className="submit-button" onClick={handleSubmit}>
              <span>Enviar</span>
            </div>
          </div>
        )}

        {/* Area do Incensário */}
        {incensarioActive && (
          <div className="incensario-area"
            style={{
              background: "url('/papel-horizontal-1.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "40ch"
            }}
          >
            <div className="close-button" onClick={() => setIncensarioActive(false)}
              style={{
                transform: "translate(-100%, -300%)"
              }}
            >
              X
            </div>
            <p
              style={{
                fontFamily: 'Frijole, system-ui',
                fontSize: '1.5rem',
                color: 'white',
                textAlign: 'center',
                // margin: '0 20px',
                cursor: 'auto',
                alignSelf: "center",
                justifySelf: "center"
              }}
            >{incensarioText}</p>

          </div>
        )}


        {/* Area da parede */}
        {paredeTextActive && (
          <div className="incensario-area"
            style={{
              background: "url('/papel-horizontal-1.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "60ch"
            }}
          >
            <div className="close-button" onClick={() => setParedeTextActive(false)}
              style={{
                transform: "translate(350%, -500%)"
              }}
            >
              X
            </div>
            <p
              style={{
                fontFamily: 'Frijole, system-ui',
                fontSize: '1.5rem',
                color: 'white',
                textAlign: 'center',
                // margin: '0 20px',
                cursor: 'auto',
                alignSelf: "center",
                justifySelf: "center"
              }}
            >{paredeText}</p>

          </div>
        )}

        { /* Area da Lamparina */}
        {lamparinaActive && (
          <div className="lamparina-area" 
            style={{
              background: "url('/papel-horizontal-1.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "50ch"
            }}
          >
            <div className="close-button" onClick={() => setLamparinaActive(false)}
              style={{
                transform: "translate(100%, -400%)"
              }}
              >
              X
            </div>
            <p
              style={{
                fontFamily: 'Frijole, system-ui',
                fontSize: '1.5rem',
                color: 'white',
                textAlign: 'center',
                // margin: '0 20px',
                cursor: 'auto',
                alignSelf: "center",
                justifySelf: "center"
              }}
            >{lamparinaText}</p>
          </div>
        )}

      </div>
    </div>
  )
}

export default Page1;
